<template lang="pug">
  .checkout-container
    v-card#pickupOrder(
      class="table-card"
    )
      v-card-title 
        v-icon.mr-2 mdi-human-greeting
        span Pick Up
        v-spacer
        v-btn(
          small
          class="red"
          @click="reset"
        ) Reset
      v-spacer
      v-card-subtitle
        b Pick a Time
      v-row(
        justify="space-around"
        align="center"
      )
        v-col(
          cols="10"
        )
          v-time-picker(
            v-model="selectedTime"
            :allowed-hours="allowedHours"
            :allowed-minutes="allowedStep"
            class="mt-4"
            ampm-in-title
            :min="minimumTime"
            max="22:00"
            elevation="1"
            format="24hr"
            :landscape="$vuetify.breakpoint.smAndUp"
          )
    v-card(
      class="checkout-card"
    )
      v-card-title
        h3.header-title Confirm your order
      v-card-text
        v-form(
          v-model="valid"
          ref="pickup"
          lazy-validation
        )
          v-text-field(
            label="Pickup time"
            v-model="setTime"
            :rules="[v => !!v || 'required']"
            readonly
            required
            append-icon="mdi-eye"
          )
          v-text-field(
            v-model="phoneNo"
            label="Customer Phone Number"
            :rules="[v => !!v || 'Phone Number is required', v => !/^\d+$/.test(v) || 'Phone number must be valid']"
            required
            append-icon="mdi-pencil"
          )
      v-card-text
        v-textarea(
          class="mt-4 m-2 pt-4"
          clearable
          clear-icon="mdi-close-circle"
          label="Remarks"
          v-model="remarks"
        )
        v-row(
          v-if="$store.getters.isLoggedIn"
          class="cart-card-button"
          align="center"
        )
          v-text-field(
            ref="promoCodeField"
            label="Promo Code"
            v-model="promoCode"
            :rules="[promotionalLimitReached]"
            prepend-icon="mdi-sale"
            append-outer-icon="mdi-send"
            @click:append-outer="applyPromo"
          )
          //-v-btn(
            tile
            small
            color="primary"
            @click="getAssignedMerchantPromotions"
          //-) View Available Offers
          v-dialog(
            v-model="dialog"
            content-class="item-dialog"
            scrollable
            tile
          )
            template(
              v-slot:activator="{ on, attrs }"
            )
              v-btn(
                tile
                small
                color="primary"
                v-bind="attrs"
                v-on="on"
                @click="getAssignedMerchantPromotions(); dialog = true;"
              ) View Available Offers
            v-progress-circular(
              v-if="loading"
              indeterminate
              color="primary"
              :size="100"
            )
            v-card(v-else)
              template(v-if="!promo_merchant_list.length")
                v-card(
                    class="promotion-merchant-card"
                )
                  v-card-title
                      h3.header-title(
                        style="text-align: left;"
                      ) Available Offers
                  v-card-text
                      b This merchant does not currently have any offers.
              template(v-else)
                v-card(
                  class="promotion-merchant-card"
                ) 
                  v-card-title
                      h3.header-title Available Offers
                  v-list(
                    three-line
                  )
                    template(
                      v-for="(p, index) in promo_merchant_list"
                    )
                      v-card(
                        color="white"
                        class="mx-2 px-2 py-2"
                        :key="p.promo_id"
                      ) 
                        v-chip(
                          small
                          outlined
                          class="ml-4 red"
                          label text-color="red darken-4"
                        ) Limited Offer
                        v-card-text 
                          b {{ p.promo_code }}
                        v-card-text(
                          style="display: flex; justify-content: space-between;"
                        ) Valid until {{ parseDate(p.promo_enddate) }}
                          v-btn(
                            :class="'green'"
                            style="outline: none;"
                            @click="inputChosenPromoCode(p.promo_code); dialog = false;"
                          ) REDEEM
        v-row(
          v-else
          class="cart-card-button"
          align="center"
        )
          em Login to Enjoy Promotional Code
        v-row(
          v-if="!promoApplied"
          class="cart-card-button"
          align="center"
        )
          b Total: 
            span.text-success RM {{ recalculatedSalePrice.toFixed(2) }}
        v-row(
          v-else
          class="cart-card-button"
          align="center"
        )
          b.d-flex 
            div Total: 
            .mx-2.text-warning.small.text-decoration-line-through RM {{ recalculatedSalePrice.toFixed(2) }} 
            div.text-success RM {{ finalPrice }}
          em.text-danger.small Discount: RM {{ promoDiscount }}
        v-row(
          class="cart-card-button"
          align="center"
        )
          v-btn(
            tile
            color="green"
            @click="checkout"
          )
            v-icon(center) mdi-cash
            span Confirm Order
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import parseDate from "@/mixins/parseDate";

export default {
  mixins: [parseDate],
  props: {
    oriPrice: Number,
    salePrice: Number,
    minPrice: Number,
    extraPrice: Number
    // orderType: Number
  },
  data() {
    return {
      valid: false,
      dialog: false,
      remarks: "",
      phoneNo: "",
      selectedTime: null,
      promo_merchant_list: [],
      promoCode: "",
      promoApplied: null,
      isReachedPromoLimit: false,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    cart() {
      return this.$store.getters.cart;
    },
    dateTimeList() {
      return [];
    },
    minimumTime() {
      return new Date().getHours() > 10 &&
        new Date().toISOString().substr(0, 10) == this.selectedDate
        ? new Date().getHours().toString() + ":00"
        : "10:00";
    },
    promotionalLimitReached() {
      return this.isReachedPromoLimit ? "Redemption limit reached" : true;
    },
    promoDiscount() {
      return this.promoApplied
        ? (
            (this.recalculatedSalePrice * this.promoApplied.promo_salepercent) /
            100
          ).toFixed(2) > this.promoApplied.promo_salemax
          ? this.promoApplied.promo_salemax
          : (
              (this.recalculatedSalePrice * this.promoApplied.promo_salepercent) /
              100
            ).toFixed(2)
        : 0;
    },
    finalPrice() {
      return (this.recalculatedSalePrice - this.promoDiscount).toFixed(2);
    },
    recalculatedOriPrice() {
      return this.oriPrice < this.minPrice ? this.oriPrice + this.extraPrice : this.oriPrice;
    },
    recalculatedSalePrice() {
      return this.salePrice < this.minPrice ? this.salePrice + this.extraPrice : this.salePrice;
    }, 
    minDate() {
      var date = new Date();
      return new Date().getHours() > 10
        ? new Date(Date.now() + 3600 * 1000 * 24).toISOString().substr(0, 10)
        : new Date().toISOString().substr(0, 10);
    },
    setTime() {
      return this.selectedTime
        ? `${this.$moment().format("YYYY-MM-DD")} ${this.selectedTime}:00`
        : "";
    }
  },
  mounted() {
    // this.inputChosenPromoCode();
  },
  methods: {
    reset() {
      this.$emit("reset");
    },
    allowedHours: v => v,
    allowedStep: m => m % 15 === 0,
    // Method for viewing page containing promotions assigned to merchant
    getAssignedMerchantPromotions() {
      // Commented code below used for redirecting to PromotionsMerchant.vue (DEPRECATED as we are using dialog boxes to get the assigned promotions merchant code)
      // this.$router.push(`/customer/promotions_merchant?merchantId=${this.cart.merchant_id}&orderType=${this.orderType}`);

      let url = config.promoUrl();

      var json = {
        params: {
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken,
          merchant_id: this.cart.merchant_id
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.promo_merchant_list = response.body.data;
                console.log(this.promo_merchant_list);
              } else {
                this.$swal(
                  this.$t("error.get_merchant_promo_list"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_promo_list"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_promo_list"),
            response.body.message,
            "error"
          );
        });
    },
    // Auto assigns promotion code if promo code is chosen from PromotionsMerchant.vue
    inputChosenPromoCode(chosenPromoCode) {
      // Both lines of commented code below used for getting chosen promo code from PromotionsMerchant.vue 
      //  (DEPRECATED as we are using dialog boxes to redeem assigned merchant promotion code)
      // let chosenPromoCode = this.$route.params.promoCode;

      // typeof chosenPromoCode !== "undefined" ? this.promoCode = chosenPromoCode : "";

      this.promoCode = chosenPromoCode;
    },
    checkout() {
      if (!this.$refs.pickup.validate()) return;
      if (!this.$store.getters.isLoggedIn) {
        this.$swal(
          this.$t("error.login_first"),
          'Login before making order',
          "error"
        ).then(result => {
          if (result.isConfirmed) {
            this.$router.push("/login");
          }
        });
        return;
      }

      let url = config.orderUrl();

      var json = {
        order_type: 3,
        merchant_id: this.cart.merchant_id,
        store_id: this.cart.store_id,
        order_oriprice: this.recalculatedOriPrice.toFixed(2),
        order_saleprice: this.recalculatedSalePrice.toFixed(2),
        order_servicecharge: 0,
        order_sst: 0,
        order_promoapplied: typeof this.promoApplied === "undefined" || this.promoApplied === null ? "" : this.promoApplied.promo_id,
        order_promodiscount: this.promoDiscount,
        order_finalprice: this.finalPrice,
        order_remarks: this.remarks,
        order_list: this.cart.order_list,
        pickup_settime: this.setTime,
        transaction_type: 'online',
        customer_phoneno: this.phoneNo,
        customer_id: this.$store.getters.customerId,
        customer_sessiontoken: this.$store.getters.sessionToken
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.$store.commit("customer/updateCheckout", {
                  orderId: response.body.orderId,
                  suborderId: response.body.suborderId,
                  orderRemarks: this.remarks,
                  orderDesc:
                    this.cart.merchant_id +
                    " - Pickup Time: " +
                    this.selectedTime,
                  orderAmount: this.finalPrice
                });
                this.$store.commit("customer/clearCart");
                this.$router.push("/checkout");
              } else {
                this.$swal(
                  this.$t("error.customer_create_order"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.customer_create_order"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.customer_create_order"),
            response.body.message,
            "error"
          );
        });
    },
    applyPromo() {
      let url = config.applyPromoUrl();

      var json = {
        merchant_id: this.cart.merchant_id,
        promo_code: this.promoCode,
        promo_type: this.$store.getters.businessType,
        customer_id: this.$store.getters.customerId,
        customer_sessiontoken: this.$store.getters.sessionToken
      };

      console.log(json);

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                // Checking for customer apply promo limit
                if (response.body.data[0].promo_usable <= 0) {
                  this.isReachedPromoLimit = true;
                  this.$refs.promoCodeField.validate();

                  return;
                }

                this.isReachedPromoLimit = false;
                this.$refs.promoCodeField.validate();
                
                this.promoApplied = response.body.data[0];
              } else {
                this.$swal(
                  this.$t("error.apply_promo"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.apply_promo"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.apply_promo"),
            response.body.message,
            "error"
          );
        });
    },
  }
};
</script>
